"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * @Author: edvardchen
 * @Date:   2016-12-08 21:06:03
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-12-08 21:06:31
 */
var qbBizIdMap = {
  wechathot: 2,
  coolread: 1,
  tag: 3
};

exports.default = qbBizIdMap;